import { render, staticRenderFns } from "./DailyReservationHome.vue?vue&type=template&id=b23e3b6a"
import script from "./DailyReservationHome.vue?vue&type=script&lang=js"
export * from "./DailyReservationHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports